import { render } from "./ProductCenterPage.vue?vue&type=template&id=585e0bd1&scoped=true"
import script from "./ProductCenterPage.vue?vue&type=script&lang=js"
export * from "./ProductCenterPage.vue?vue&type=script&lang=js"

import "./ProductCenterPage.vue?vue&type=style&index=0&id=585e0bd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585e0bd1"]])

export default __exports__